// extracted by mini-css-extract-plugin
export default {"root":"_2PvIo","body":"_1Pn3y","footer":"_2rIac","user-field":"O5O-i","userField":"O5O-i","user-input":"_2N6XQ","userInput":"_2N6XQ","prefix":"SPXRB"};